<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <selectlist
          :options="referredByOptions"
          label="Referred By"
          name="referred_by_id"
          helper="Please select a name"
          placeholder="Please Select"
          label-name="full_name"
          key-name="id"
          v-model="form.referred_by_id"
          :show-error="form.errors.has('referred_by_id')"
          :error-message="form.errors.get('referred_by_id')"
        ></selectlist>

        <datepicker-input
          name="referred_date"
          label="Referred Date"
          helper="Please enter the referred date"
          v-model="form.referred_date"
        ></datepicker-input>

        <selectlist
          :options="escalationManagerOptions"
          label="Accepted By"
          name="accepted_by_id"
          helper="Please select"
          placeholder="Please Select"
          label-name="full_name"
          key-name="id"
          v-model="form.accepted_by_id"
          :show-error="form.errors.has('accepted_by_id')"
          :error-message="form.errors.get('accepted_by_id')"
        ></selectlist>

        <datepicker-input
          name="accepted_date"
          label="Accepted Date"
          helper="Please enter the accepted date"
          v-model="form.accepted_date"
        ></datepicker-input>
      </div>

      <div class="col-lg-6">
        <selectlist
          :options="escalationManagerOptions"
          label="Rejected By"
          name="rejected_by_id"
          helper="Please select"
          placeholder="Please Select"
          label-name="full_name"
          key-name="id"
          v-model="form.rejected_by_id"
          :show-error="form.errors.has('rejected_by_id')"
          :error-message="form.errors.get('rejected_by_id')"
        ></selectlist>

        <datepicker-input
          name="rejected_date"
          label="Rejected Date"
          helper="Please enter the rejected date"
          v-model="form.rejected_date"
        ></datepicker-input>

        <datepicker-input
          name="date_bundle_sent"
          label="Date Bundle Sent"
          helper="Please enter the date the bundle was sent"
          v-model="form.date_bundle_sent"
        ></datepicker-input>

        <selectlist
          :options="escalationManagerOptions"
          label="Bundle Sent By"
          name="bundle_sent_by_id"
          helper="Please select"
          placeholder="Please Select"
          label-name="full_name"
          key-name="id"
          v-model="form.bundle_sent_by_id"
          :show-error="form.errors.has('bundle_sent_by_id')"
          :error-message="form.errors.get('bundle_sent_by_id')"
        ></selectlist>
      </div>
    </div>

    <div class="text-right mt-3">
      <form-button :indicator="processing" @clicked="submit">Save</form-button>
    </div>
  </div>
</template>

<script>
// The roles whose members can refer a claim to the escalations team.
const REFERRER_ROLES = [
  'on_hire',
  'employee_on_hire',
  'manager',
  'senior_manager'
];

// The role whose members handle escalation referrals.
const ESCALATION_MANAGER_ROLE = 'escalation_manager';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    section: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      processing: false,
      form: new window.Form({
        referred_by_id: null,
        referred_date: null,
        accepted_by_id: null,
        accepted_date: null,
        rejected_by_id: null,
        rejected_date: null,
        date_bundle_sent: null,
        bundle_sent_by_id: null
      }),
      dateFields: [
        'referred_date',
        'accepted_date',
        'rejected_date',
        'date_bundle_sent'
      ]
    };
  },

  computed: {
    /**
     * The active users available to be selected against a referral.
     */
    activeHandlers() {
      return (this.$store.getters['ClaimHandlers/all'] || []).filter(
        user => !user.locked_at
      );
    },

    /**
     * The active users assigned to the roles that can refer a claim.
     */
    referredByOptions() {
      return this.activeHandlers.filter(user =>
        REFERRER_ROLES.includes(user.role)
      );
    },

    /**
     * The active escalation managers, who accept, reject and send bundles.
     */
    escalationManagerOptions() {
      console.log('activeHandlers', this.activeHandlers);
      return this.activeHandlers.filter(
        user => user.role === ESCALATION_MANAGER_ROLE
      );
    }
  },

  watch: {
    section: {
      handler: 'hydrate',
      immediate: true
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');
  },

  methods: {
    hydrate(d) {
      if (!d) {
        return;
      }

      this.form.referred_by_id = d.referred_by_id;
      this.form.accepted_by_id = d.accepted_by_id;
      this.form.rejected_by_id = d.rejected_by_id;
      this.form.bundle_sent_by_id = d.bundle_sent_by_id;

      // The api returns the dates as utc iso strings, so parse them back into
      // date objects to keep the datepickers in the users local timezone.
      this.dateFields.forEach(field => {
        this.form[field] = d[field] ? window.DateManager.parse(d[field]) : null;
      });
    },

    /**
     * Get the form data with the dates formatted in the users local timezone.
     */
    payload() {
      const data = this.form.data();

      this.dateFields.forEach(field => {
        data[field] = data[field]
          ? window.DateManager.format(data[field], 'YYYY-MM-DD HH:mm:ss')
          : null;
      });

      return data;
    },

    submit() {
      this.processing = true;

      window.Ajax.put(
        `/debt-recovery/${this.incident}/referrals`,
        this.payload()
      )
        .then(response => {
          this.processing = false;
          this.form.errors.clear();
          this.$emit('saved', response.data);
          window.toastify.success(
            'Success!',
            'The referral was saved successfully!'
          );
        })
        .catch(error => {
          this.processing = false;

          const data = error.response ? error.response.data : null;

          if (data && data.errors) {
            this.form.errors.record(data.errors);
          }

          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the referral'
          );
        });
    }
  }
};
</script>
